import React from 'react';
import { withHydrate } from '@ecommerce/nest-ssr/common';

import StaticLayoutDesktop from 'layouts/static/static.desktop';
import NewsListBase from './news-list.base';

const NewsListDesktop: React.FC<{ title: string; }> = ({ title }) => (
    <StaticLayoutDesktop title={title}>
        <NewsListBase />
    </StaticLayoutDesktop>
);

export default withHydrate(NewsListDesktop, { root: '#root' }, 'views/pages/news/list/news-list.desktop');
